import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

/**
 * Member name with optional special-handling flag + tooltip.
 */
export const SpecialMemberHandlingName = ({ name, tooltip = undefined }) => (
    <span className="flex__gap--x-small" style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span>{name}</span>
        {tooltip?.length > 0 ? (
            <Icon
                icon={IconNames.FLAG}
                intent={Icon.Intent.WARNING}
                tooltipContent={
                    <>
                        {tooltip.map((msg) => (
                            <div key={msg}>{msg}</div>
                        ))}
                    </>
                }
                title="Special handling"
            />
        ) : null}
    </span>
);

SpecialMemberHandlingName.propTypes = {
    name: PropTypes.node.isRequired,
    tooltip: PropTypes.arrayOf(PropTypes.string),
};
